module.exports = __webpack_public_path__ + "static/img/chinaCoOp.1b2f779e.png";